import React from "react";

export const ArrowYellowBg: React.FC<{}> = () => (
  <svg
    width="25px"
    height="26px"
    viewBox="0 0 25 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Arrow</title>
    <g
      id="Homepage"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Grow-Your-Business-Auth-C-"
        transform="translate(-146.000000, -1497.000000)"
      >
        <g id="upcoming-events" transform="translate(51.000000, 1095.000000)">
          <g
            id="your-upcoming-events"
            transform="translate(0.000000, 0.422348)"
          >
            <g id="Group-6" transform="translate(0.000000, 82.500000)">
              <g
                id="2.-Text-links/1.-Text-+-Icon-+-2-lines/LG"
                transform="translate(0.000000, 319.286024)"
              >
                <g id="Arrow" transform="translate(95.000000, 0.000000)">
                  <circle
                    id="Oval"
                    fill="#FFCF00"
                    cx="12.5"
                    cy="12.5"
                    r="12.5"
                  />
                  <g id="Group">
                    <rect id="Rectangle" x="0" y="0" width="25" height="25" />
                    <line
                      x1="5"
                      y1="12.5"
                      x2="20"
                      y2="12.5"
                      id="Path"
                      stroke="#252525"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <polyline
                      id="Path"
                      stroke="#252525"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      points="13.6538462 6.25 20 12.5 13.6538462 18.75"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default {};
